import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { 
    useBlockProps, 
    InspectorControls,
    InnerBlocks
} from '@wordpress/block-editor';
import { 
    PanelBody,
    Placeholder,
    Button,
    TabPanel,
    ToggleControl
} from '@wordpress/components';
import './style.scss';
import './editor.scss';
import VisibilityControl from '../../components/VisibilityControl';
import FlatColorPicker from '../../components/FlatColorPicker';

registerBlockType('kanews/timeline', {
    title: __('Zaman Çizelgesi', 'kanews'),
    category: 'kanews',
    icon: 'clock',
    supports: {
        html: false,
        align: ['wide', 'full', 'center', 'left', 'right', 'justify', 'full']
    },
    attributes: {
        showShare: {
            type: 'boolean',
            default: true
        },
        primaryColor: {
            type: 'string',
            default: ''
        },
        borderColor: {
            type: 'string',
            default: ''
        },
        visibility: {
            type: 'object',
            default: {
                desktop: false,
                tablet: false,
                mobile: false
            }
        }
    },
    edit: ({ attributes, setAttributes }) => {
        const blockProps = useBlockProps();
        const { primaryColor, borderColor, visibility } = attributes;

        const tabs = [
            {
                name: 'content',
                title: __('İçerik', 'kanews'),
                className: 'content-tab'
            },
            {
                name: 'design',
                title: __('Tasarım', 'kanews'),
                className: 'design-tab'
            },
            {
                name: 'visibility',
                title: __('Görünürlük', 'kanews'),
                className: 'visibility-tab'
            }
        ];

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="kanews-tab-panel"
                        tabs={tabs}
                    >
                        {(tab) => {
                            return (
                                <>
                                    {tab.name === 'content' && (
                                        <PanelBody>
                                            <ToggleControl
                                                label={__('Paylaşım Butonu', 'kanews')}
                                                checked={attributes.showShare}
                                                onChange={(value) => setAttributes({ showShare: value })}
                                            />
                                        </PanelBody>
                                    )}

                                    {tab.name === 'design' && (
                                        <PanelBody>
                                            <FlatColorPicker
                                                label={__('Birincil Renk', 'kanews')}
                                                value={attributes.primaryColor}
                                                onChange={(value) => setAttributes({ primaryColor: value })}
                                            />
                                            <FlatColorPicker
                                                label={__('Kenarlık Rengi', 'kanews')}
                                                value={attributes.borderColor}
                                                onChange={(value) => setAttributes({ borderColor: value })}
                                            />
                                        </PanelBody>
                                    )}

                                    {tab.name === 'visibility' && (
                                        <PanelBody>
                                            <VisibilityControl
                                                value={attributes.visibility}
                                                onChange={(value) => setAttributes({ visibility: value })}
                                            />
                                        </PanelBody>
                                    )}
                                </>
                            );
                        }}
                    </TabPanel>
                </InspectorControls>
                <div {...blockProps}>
                    <div className={`kanews-timeline-news ${visibility.desktop ? 'hidden-desktop' : ''} ${visibility.tablet ? 'hidden-tablet' : ''} ${visibility.mobile ? 'hidden-mobile' : ''}`} style={{ '--timeline-color': primaryColor || undefined, '--kan-border-color2': borderColor || undefined }}>
                        <InnerBlocks
                            allowedBlocks={['kanews/timeline-item']}
                            template={[
                                ['kanews/timeline-item']
                            ]}
                            renderAppender={InnerBlocks.ButtonBlockAppender}
                        />
                    </div>
                </div>
            </>
        );
    },
    save: ({ attributes }) => {
        const blockProps = useBlockProps.save();
        const { showShare, primaryColor, visibility, borderColor } = attributes;

        return (
            <div {...blockProps}>
                <div className={`kanews-timeline-news ${visibility.desktop ? 'hidden-desktop' : ''} ${visibility.tablet ? 'hidden-tablet' : ''} ${visibility.mobile ? 'hidden-mobile' : ''}`} style={{ '--timeline-color': primaryColor || undefined, '--kan-border-color2': borderColor || undefined }}>
                    <InnerBlocks.Content />
                </div>
            </div>
        );
    }
}); 